import { render, staticRenderFns } from "./modalAddAdvertisementNew.vue?vue&type=template&id=0d49356c&"
import script from "./modalAddAdvertisementNew.vue?vue&type=script&lang=js&"
export * from "./modalAddAdvertisementNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports